module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "post-edit"
    }
  }, [_h('div', {
    staticClass: "mt-1"
  }, [_h('button', {
    staticClass: "btn btn-sm btn-secondary",
    on: {
      "click": _vm.volver
    }
  }, ["Volver"])]), " ", _h('h1', [_vm._s(_vm.title)]), " ", (_vm.cargando) ? _h('div', [_h('h2', ["CARGANDO POST"])]) : _vm._e(), " ", (!_vm.cargando) ? _h('div', [_h('div', {
    staticClass: "form-group"
  }, [_vm._m(0), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.fecha),
      expression: "post.fecha"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "fecha",
      "type": "date"
    },
    domProps: {
      "value": _vm._s(_vm.post.fecha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.fecha = $event.target.value
      }
    }
  })]), " ", _h('div', {
    staticClass: "form-group"
  }, [_vm._m(1), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.post.titulo),
      expression: "post.titulo",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "titulo",
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.post.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.titulo = $event.target.value.trim()
      }
    }
  })]), " ", _h('div', {
    staticClass: "form-group"
  }, [_vm._m(2), " ", _h('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.post.descripcionCorta),
      expression: "post.descripcionCorta",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    domProps: {
      "value": _vm._s(_vm.post.descripcionCorta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.descripcionCorta = $event.target.value.trim()
      }
    }
  })]), " ", _h('div', {
    staticClass: "form-group"
  }, [_vm._m(3), " ", _h('quill-editor', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.descripcion),
      expression: "post.descripcion"
    }],
    staticClass: "wpo-editor",
    attrs: {
      "id": "wpoEditor",
      "config": _vm.editorOption
    },
    domProps: {
      "value": (_vm.post.descripcion)
    },
    on: {
      "input": function($event) {
        _vm.post.descripcion = $event
      }
    }
  })]), " ", _h('hr'), " ", _h('h4', {
    staticClass: "text-xs-center"
  }, ["Fuentes"]), " ", _h('div', {
    staticClass: "row"
  }, [_h('div', {
    staticClass: "col-md-4"
  }, [_h('div', {
    staticClass: "form-group"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.fuente.titulo),
      expression: "fuente.titulo",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "titulo",
      "type": "text",
      "placeholder": "Titulo"
    },
    domProps: {
      "value": _vm._s(_vm.fuente.titulo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fuente.titulo = $event.target.value.trim()
      }
    }
  })])]), " ", _h('div', {
    staticClass: "col-md-6"
  }, [_h('div', {
    staticClass: "form-group"
  }, [_h('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.fuente.link),
      expression: "fuente.link",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "id": "titulo",
      "type": "text",
      "placeholder": "Enlace"
    },
    domProps: {
      "value": _vm._s(_vm.fuente.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fuente.link = $event.target.value.trim()
      }
    }
  })])]), " ", _h('div', {
    staticClass: "col-md-2"
  }, [_h('button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.agregarEnlace
    }
  }, ["Agregar"])])]), " ", _h('div', [_h('table', {
    staticClass: "table"
  }, [_vm._l((_vm.post.fuentes), function(enlace, index) {
    return _h('tr', [_h('td', [_h('a', {
      attrs: {
        "target": "_blank",
        "href": enlace.link
      }
    }, [_vm._s(enlace.titulo)])]), " ", _h('td', [_h('button', {
      staticClass: "btn btn-sm btn-danger",
      on: {
        "click": function($event) {
          _vm.borrarEnlace(index)
        }
      }
    }, ["X"])])])
  }), " "])]), " ", _h('div', {
    staticClass: "row mt-3"
  }, [_h('div', {
    staticClass: "col-sm-4 text-left"
  }, [(!_vm.nuevo) ? _h('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.eliminar
    }
  }, ["Eliminar"]) : _vm._e()]), " ", _h('div', {
    staticClass: "col-sm-4"
  }, [_h('button', {
    staticClass: "btn btn-primary btn-block",
    on: {
      "click": _vm.guardar
    }
  }, ["Guardar"])]), " ", _h('div', {
    staticClass: "col-sm-4"
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;
  return _h('label', [_h('b', ["Fecha"])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('label', [_h('b', ["Titulo"])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('label', [_h('b', ["Descripción corta"])])
},function (){var _vm=this;var _h=_vm.$createElement;
  return _h('label', [_h('b', ["Descripción completa"])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52c13a03!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Post-Edit.vue
// module id = 200
// module chunks = 2